import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Values } from '../components/Values';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Services } from '../components/Services';
import { TargetMarket } from '../components/TargetMarket';
import { LoanProcess } from '../components/LoanProcess';
import { Requirements } from '../components/Requirements';
import { FormsDocuments } from '../components/FormsDocuments';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function HomePage() {
  return <div className="min-h-screen bg-offwhite font-sans text-navy" data-id="element-651">
      <Navbar data-id="element-652" />
      <main data-id="element-653">
        <Hero data-id="element-654" />
        <About data-id="element-655" />
        <Values data-id="element-656" />
        <WhyChooseUs data-id="element-657" />
        <Services data-id="element-658" />
        <TargetMarket data-id="element-659" />
        <LoanProcess data-id="element-660" />
        <Requirements data-id="element-661" />
        <FormsDocuments data-id="element-662" />
        <Contact data-id="element-663" />
      </main>
      <Footer data-id="element-664" />
      <WhatsAppButton data-id="element-665" />
    </div>;
}